import React from "react"
import {
  Popover as MUIPopover,
  PopoverProps as MUIPopoverProps,
} from "@mui/material"

export type PopoverProps =
  | ({ new?: false } & MUIPopoverProps)
  | ({ new: true } & unknown)

export const Popover = React.forwardRef<HTMLDivElement, PopoverProps>(
  (props, ref) => (props.new ? null : <MUIPopover ref={ref} {...props} />),
)

Popover.displayName = "Popover"

export default Popover
